import React, { useState, useEffect } from "react";
// efeito de skeleton (mesmo usado no LoadingSkelentonTable)
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import {
  Table,
  Card,
  CardTitle,
  CardBody,
  Button,
  Spinner,
  Collapse,
  Row,
} from "reactstrap";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
//redux
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
//service
import {
  getParticipants,
  deleteParticipant,
  deleteAllParticipants,
  reactivateParticipant,
  verifyToDelete,
  verifyToDeleteAll,
} from "../../../utils/services/participants";
import {
  addLoginInNotificationsScheduled,
  removeLoginInNotificationsScheduled,
} from "../../../utils/services/notification";
import {
  getQuotas,
  disableAllQuotas,
  getSessionUser,
} from "../../../utils/services/quotas";
//paginação
import Pagination from "../../../components/Paginationv3";
//componentes
import ModalNewParticipant from "./ModalNewParticipant";
import ModalEditParticipant from "./ModalEditParticipant";
import ModalImportWrapper from "./ModalImportWrapper";
import ModalEditPassword from "./ModalEditPassword";
import ModalSendEmail from "./ModalSendEmail";
import ModalExportParticipants from "./ModalExportParticipants";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import IconButton from "../../../components/Buttons/IconButton";
import ModalViewLogistics from "./logistics/ModalViewLogistics";
import ModalParticipantForm from "./ModalParticipantForm";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
import WaitExport from "../../../components/WaitExport";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../components/SearchFilters";
// utils
import useDebounce from "../../../utils/hooks/useDebounce";
import { createXlsx } from "./createXlsx";
import { createXlsxQuota } from "./createXlsxQuota";
import { createXlsxDynamic } from "./createXlsxDynamic";

// MOCK de teste — deixe `true` para abrir o modal de exportação mesmo em
// eventos sem o produto RSVP. Em produção mantenha `false`.
const MOCK_RSVP_PRODUCT = false;

const columnsFilter = [
  { name: "Nome", value: "login", type: "text" },
  { name: "Email", value: "email", type: "text" },
  { name: "Código Interno 1", value: "codigointerno1", type: "text" },
  { name: "Código Interno 2", value: "codigointerno2", type: "text" },
  { name: "Código Interno 3", value: "codigointerno3", type: "text" },
];
function Participants(props) {
  const { dashAccess = false } = props;
  const location = useLocation();
  const idEvent = location.state.idEvent;
  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewParticipant, setModalNewParticipant] = useState(false);
  const [modalEditParticipant, setModalEditParticipant] = useState(false);
  const [modalImportWrapper, setModalImportWrapper] = useState(false);
  const [modalEditPassword, setModalEditPassword] = useState(false);
  const [modalSendEmail, setModalSendEmail] = useState(false);
  const [modalViewLogistics, setModalViewLogistics] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  const [modalExportParticipants, setModalExportParticipants] = useState(false);
  const [modalParticipantForm, setModalParticipantForm] = useState(false);
  // participante selecionado para o formulário
  const [participantFormData, setParticipantFormData] = useState(null);
  // logistica do participante
  const [logisticUser, setLogisticUser] = useState(null);
  //deletar participante
  const [deleteParticipantState, setDeleteParticipantState] = useState();
  const [deleteQuotaData, setDeleteQuotaData] = useState(null);
  const [participant, setParticipant] = useState();
  const [activateQuotaData, setActivateQuotaData] = useState(null);
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [confirmAlertReactivate, setConfirmAlertReactivate] = useState(false);
  // alerta
  const [successDlg, setSuccessDlg] = useState(false);
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [dynamicDescription, setDynamicDescription] = useState("");
  const [alertEmail, setAlertEmail] = useState(false);
  const [alertEmailConfirm, setAlertEmailConfirm] = useState(false);
  //editar participante
  const [editParticipante, setEditParticipante] = useState();
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  //state de participants
  const [participants, setParticipants] = useState([]);
  //estado com a quantidade total de items na API
  const [countData, setCountData] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // serviços do usuario e do evento ativos
  const [serviceInUse, setServiceInUse] = useState([]);
  const [serviceInUseEvent, setServiceInUseEvent] = useState([]);

  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [transition, setTransition] = useState(false);
  const [updateNotification, setUpdateNotification] = useState(false);
  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // collapse state
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("login");
  const [productsList, setProductsList] = useState([]);
  // botões de importar e exportar
  const [importers, setImporters] = useState(true);
  // cotas
  const [quotas, setQuotas] = useState([]);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  // confirma excluir todos
  const [textConfirm, setTextConfirm] = useState("");
  // token
  const token = props.state.global_user_data.data.token;

  const debouncedSearch = useDebounce(search, 300);

  // atualiza o filtro ativo e limpa a busca
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // inverte a data de dd/mm/yyyy para yyyy-mm-dd para envio à API
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  // formata o termo de busca de acordo com o tipo do filtro ativo
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // abre/fecha modal de novo participante
  function toggleNewParticipant() {
    setModalNewParticipant(!modalNewParticipant);
  }

  // abre/fecha modal de edição de participante
  function toggleEditParticipant() {
    setModalEditParticipant(!modalEditParticipant);
  }

  // abre/fecha modal de importação
  function toggleImportWrapper() {
    setModalImportWrapper(!modalImportWrapper);
  }

  // abre/fecha modal de edição de senha
  function toggleEditPassword() {
    setModalEditPassword(!modalEditPassword);
  }

  // abre/fecha modal de formulário do participante
  function toggleParticipantForm() {
    setModalParticipantForm(!modalParticipantForm);
  }

  // verifica se um produto está ativo no evento
  function checkProductExists(product) {
    if (location.state) {
      const search = location.state.event.product.filter(
        (e) => e.name === product,
      );

      if (search[0]) {
        return true;
      } else return false;
    }
  }

  // exporta o relatório simples de participantes
  function exportSimpleReport() {
    createXlsx({
      jwt: token,
      idEvent: idEvent,
      limit: 500,
      search: search,
      status: status,
      countData,
      setFinishExport,
    });
    setExportInProgress(true);
  }

  // exporta o relatório dinâmico: colunas padrão + colunas dos formulários RSVP
  function exportDynamicReport({ selectedForms }) {
    createXlsxDynamic({
      idEvent: idEvent,
      limit: 500,
      search: search,
      status: status,
      countData,
      selectedForms,
      setFinishExport,
    }).catch((error) => {
      setExportInProgress(false);
      setFinishExport(false);
      toast.error(error.message || "Erro ao gerar o relatório dinâmico.");
    });
    setExportInProgress(true);
  }

  // com RSVP no evento abre o modal de opções, senão exporta direto o simples
  function handleExportParticipants() {
    if (MOCK_RSVP_PRODUCT || checkProductExists("RSVP")) {
      setModalExportParticipants(true);
      return;
    }

    exportSimpleReport();
  }

  // busca a lista paginada de participantes do evento
  const getAllParticipants = async () => {
    setLoading(true);
    try {
      const formData = await getParticipants({
        jwt: token,
        idEvent: idEvent,
        offset: currentIndex > 0 ? currentIndex : 1,
        limit: itemsPerPage,
        search: treatmentSearch(),
        columnSearch: activeFilter,
        status: status ? "ATIVO" : "INATIVO",
      });
      setCountData(formData?.data?.count);
      setParticipants(formData?.data?.data ?? []);
    } catch (error) {
      setCountData(0);
      setParticipants([]);
      toast.error("Erro ao carregar participantes.");
    } finally {
      setLoading(false);
      setTransition(false);
    }
  };

  // formata uma data ISO para dd/mm/yyyy
  function formatData(startDate) {
    const data = new Date(startDate);
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();
    const dataAtual = dia + "/" + mes + "/" + ano;

    return dataAtual;
  }

  // desativa o participante e atualiza notificações e cotas vinculadas
  async function confirmDelete(email) {
    const formData = await deleteParticipant(
      deleteParticipantState.id,
      token,
      idEvent,
    );
    if (formData.message === "USER_DISABLED") {
      try {
        const res = await removeLoginInNotificationsScheduled(
          location?.state?.idEvent,
          deleteParticipantState.id,
        );
        setUpdateNotification(res.data);

        if (checkProductExists("Distribuição de Cotas") && deleteQuotaData) {
          const dataDisableCotas = {
            eventId: idEvent,
            loginId: deleteParticipantState.id,
            isSendEmail: email ? true : false,
            subject: email ? email.subject : "",
            templateBase: email ? email.template.current.getContent() : "",
          };

          await disableAllQuotas({
            jwt: token,
            data: dataDisableCotas,
          });
        }
      } catch (error) {
      } finally {
        setConfirmAlert(false);
        setSuccessDlg(true);
        setDynamicTitle("Sucesso");
        setDynamicDescription("Participante deletado com sucesso");
        // modal e alerta de email
        setModalSendEmail(false);
        setAlertEmail(false);
      }

      getAllParticipants();
    }
  }

  // reativa o participante e atualiza notificações agendadas
  async function confirmReactivate() {
    let arrayGroups = [];

    const formData = await reactivateParticipant(
      idEvent,
      participant?.id,
      token,
    );
    if (participant?.grupos?.length > 0) {
      participant.grupos.map((e) => arrayGroups.push({ grupo: e.grupo.id }));
    }
    if (formData.message === "LOGIN_REACTIVATED") {
      try {
        const { data } = await addLoginInNotificationsScheduled(
          idEvent,
          participant?.id,
          token,
          arrayGroups,
        );
        setUpdateNotification(data);
      } catch (error) {
      } finally {
        setConfirmAlertReactivate(false);
        setSuccessDlg(true);
        setDynamicTitle("Reativado");
        setDynamicDescription("Participante reativado");
      }
      getAllParticipants();
    }
  }

  // remove todos os participantes do evento
  async function confirmDeleteAllParticipants() {
    setLoadingDelete(true);
    await deleteAllParticipants({ jwt: token, eventId: idEvent });
    setLoadingDelete(false);
    setSuccessDlg(true);
    setServiceInUseEvent([]);
    setDynamicTitle("Sucesso");
    setDynamicDescription("Participantes deletados com sucesso");
    getAllParticipants();
  }

  // retorna a data do primeiro acesso do participante no evento
  function getFirstAccess(f) {
    const data = f.eventos.filter((e) => e.event.id === idEvent)[0];
    return data?.firstAccess ? formatData(data.firstAccess) : "";
  }

  // retorna a data de inscrição do participante no evento
  function getRegistrationDate(reg) {
    const data = formatData(
      reg.eventos.find(({ event }) => event.id === idEvent)?.criadoEm,
    );
    return data ? data : "";
  }

  // retorna { description, backgroundColor, textColor } do Status RSVP do
  // participante nesse evento (ou null se não tiver status atribuído).
  function getStatusRsvpData(reg) {
    const data = reg.eventos.find(({ event }) => event.id === idEvent);
    const statusRsvp = data?.statusRsvp || data?.status_rsvp;
    if (!statusRsvp) {
      // Fallback: description isolada em outra chave (sem cor).
      if (data?.statusRsvpDescription) {
        return { description: data.statusRsvpDescription };
      }
      return null;
    }
    return {
      description: statusRsvp.description,
      backgroundColor: statusRsvp.backgroundColor,
      textColor: statusRsvp.textColor,
    };
  }

  // verificar se o evento tem o app como produto
  function checkItemMenuExists(menuOption) {
    return productsList.filter((item) => item === menuOption).length > 0;
  }

  // verificar se items de logisticas estão disponiveis para o evento
  function checkItemMenuLogisticsExists(menuOption) {
    return (
      props.state.global_user_data.data.foundProducts.filter(
        (item) => item.name === menuOption,
      ).length > 0
    );
  }

  // desativa botões de importação quando o único produto é Distribuição de Cotas
  function verifyImporters() {
    if (
      location.state &&
      location.state.event?.product?.length === 1 &&
      location.state.event.product[0].name === "Distribuição de Cotas"
    ) {
      setImporters(false);
    }
  }

  // busca as cotas do evento para validação antes de deletar
  async function getAllQuotas() {
    try {
      const res = await getQuotas({ jwt: token, id: idEvent });
      setQuotas(res.loginEventosCotas.data);
    } catch (error) {
      toast.error("Erro ao carregar cotas.");
    }
  }

  // verifica se o participante tem sessão ativa no momento
  async function getSessionUserFunc(loginId) {
    const res = await getSessionUser(token, loginId);
    return res?.totalSessionActive?.count > 0;
  }

  // retorna lista de serviços vinculados ao participante que impedem exclusão
  async function verifyDeleteParticipant(e) {
    const res = await verifyToDelete(idEvent, e.id);
    if (
      res.data.hasServices &&
      res.data.services.filter((use) => use.isPresent).length > 0
    ) {
      return res.data.services.filter((use) => use.isPresent);
    }
    return [];
  }

  // retorna lista de serviços vinculados ao evento que impedem exclusão em massa
  async function verifyDeleteAllParticipant() {
    try {
      const res = await verifyToDeleteAll(idEvent);
      if (
        res?.data?.hasServices &&
        res?.data?.services?.filter((use) => use.isPresent).length > 0
      ) {
        return res.data.services.filter((use) => use.isPresent);
      }
    } catch (erro) {
      console.log("all erro", erro);
    }
    return [];
  }

  // orquestra o fluxo de exclusão considerando cotas e sessão ativa
  async function stepByDelete(e, type) {
    setDeleteQuotaData(quotas.filter((quota) => quota.login === e.id)[0]);
    if (
      checkProductExists("Distribuição de Cotas") &&
      quotas.filter((quota) => quota.login === e.id)[0] &&
      (await getSessionUserFunc(e.id))
    ) {
      setAlertEmail(true);
    } else if (type === "noAlert") {
      setConfirmAlert(true);
    } else {
      confirmDelete();
    }

    setServiceInUse([]);
  }

  useEffect(() => {
    verifyImporters();
    getAllParticipants();
    getAllQuotas();
    setProductsList(
      [
        ...new Set(
          props.state.global_user_data.data.foundProducts.map(
            (e) => e.namemainproduct,
          ),
        ),
      ].filter((f) => f !== "Telas de Configuração"),
    );
  }, [currentIndex, itemsPerPage, debouncedSearch, status]);

  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Participantes"
          onConfirm={confirmDeleteAllParticipants}
        />
      )}

      {modalNewParticipant && (
        <ModalNewParticipant
          isOpen={modalNewParticipant}
          toggle={toggleNewParticipant}
          idEvent={idEvent}
          getAllParticipants={getAllParticipants}
        />
      )}

      {modalEditParticipant && (
        <ModalEditParticipant
          isOpen={modalEditParticipant}
          toggle={toggleEditParticipant}
          participant={editParticipante}
          getAllParticipants={getAllParticipants}
          idEvent={idEvent}
        />
      )}

      <ModalImportWrapper
        isOpen={modalImportWrapper}
        toggle={toggleImportWrapper}
        getAllParticipants={getAllParticipants}
        token={token}
        idEvent={idEvent}
      />

      {modalSendEmail && (
        <ModalSendEmail
          isOpen={modalSendEmail}
          toggle={() => setModalSendEmail(!modalSendEmail)}
          confirmDelete={confirmDelete}
        />
      )}

      {modalEditPassword && (
        <ModalEditPassword
          isOpen={modalEditPassword}
          toggle={toggleEditPassword}
          editParticipante={editParticipante}
          idEvent={idEvent}
          getAllParticipants={getAllParticipants}
        />
      )}

      {modalViewLogistics && (
        <ModalViewLogistics
          isOpen={modalViewLogistics}
          toggle={() => setModalViewLogistics(false)}
          token={token}
          idEvent={idEvent}
          user={logisticUser}
        />
      )}

      {modalParticipantForm && (
        <ModalParticipantForm
          isOpen={modalParticipantForm}
          toggle={() => {
            toggleParticipantForm();
            getAllParticipants();
          }}
          participant={participantFormData}
          eventId={idEvent}
        />
      )}

      {modalExportParticipants && (
        <ModalExportParticipants
          isOpen={modalExportParticipants}
          toggle={() => setModalExportParticipants(false)}
          eventId={idEvent}
          onExportSimple={exportSimpleReport}
          onExportDynamic={exportDynamicReport}
        />
      )}

      {confirmAlert ? (
        <SweetAlert
          title={`Deseja deletar ${deleteParticipantState.nome}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete();
          }}
          onCancel={() => setConfirmAlert(false)}
        >
          <a></a>
        </SweetAlert>
      ) : null}

      {confirmAlertReactivate ? (
        <SweetAlert
          title={`Deseja Reativar ${participant.nome}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmReactivate();
          }}
          onCancel={() => setConfirmAlertReactivate(false)}
        >
          <a></a>
        </SweetAlert>
      ) : null}

      {successDlg ? (
        <SweetAlert
          success
          title={dynamicTitle}
          onConfirm={() => {
            setSuccessDlg(false);
          }}
        >
          <>
            <p>{dynamicDescription}</p>
            {updateNotification && (
              <p style={{ color: "#218a64", fontStyle: "italic" }}>
                As Notificações agendadas foram atualizadas com esse
                participante.
              </p>
            )}
          </>
        </SweetAlert>
      ) : null}

      {alertEmail && (
        <SweetAlert
          warning
          title={"Deseja enviar email ao participante?"}
          showConfirm={false}
        >
          <div className="div-options-modal">
            <Button
              color="primary"
              className="btn btn-primary"
              onClick={() => setAlertEmail(false)}
            >
              Fechar
            </Button>
            <Button className="btn btn-danger" onClick={() => confirmDelete()}>
              Não
            </Button>
            <Button
              className="btn btn-success"
              onClick={() => {
                setModalSendEmail(true);
                setAlertEmail(false);
              }}
            >
              Sim
            </Button>
          </div>
        </SweetAlert>
      )}

      {alertEmailConfirm && (
        <SweetAlert
          success
          title={"Deletado"}
          onConfirm={() => {
            setAlertEmailConfirm(false);
          }}
        >
          Participante deletado com sucesso
        </SweetAlert>
      )}

      {serviceInUse && serviceInUse.length > 0 ? (
        <SweetAlert
          title={`O participante ${deleteParticipantState.nome} possui vínculo com o(s) serviço(s) abaixo:`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            stepByDelete(deleteParticipantState, "alert");
          }}
          onCancel={() => {
            setServiceInUse([]);
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 20,
            }}
          >
            {serviceInUse
              .sort((a, b) => {
                if (a.name < b.name) {
                  return -1;
                } else if (a.name > b.name) {
                  return 1;
                } else {
                  return 0;
                }
              })
              .map((e) => (
                <span key={e.name}>{e.name}</span>
              ))}
          </div>
          <p>Você deseja seguir com a exclusão?</p>
        </SweetAlert>
      ) : null}

      {serviceInUseEvent && serviceInUseEvent.length > 0 ? (
        <SweetAlert
          title={`O evento possui vínculo com o(s) serviço(s) abaixo:`}
          warning
          showCancel={!loadingDelete}
          showConfirm={!loadingDelete}
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          confirmBtnCssClass={
            textConfirm !== "sim, desejo deletar"
              ? "btn-sweetAlert-disabled"
              : ""
          }
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            if (textConfirm === "sim, desejo deletar")
              confirmDeleteAllParticipants();
          }}
          onCancel={() => {
            setServiceInUseEvent([]);
          }}
        >
          {loadingDelete ? (
            <>
              <Spinner
                style={{ color: "gray", marginBottom: "5px" }}
                animation="border"
                size="lg"
              />
              <p>Limpando participantes...</p>
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: 20,
                }}
              >
                {serviceInUseEvent
                  .sort((a, b) => {
                    if (a.name < b.name) {
                      return -1;
                    } else if (a.name > b.name) {
                      return 1;
                    } else {
                      return 0;
                    }
                  })
                  .map((e) => (
                    <span key={e.name}>{e.name}</span>
                  ))}
              </div>
              <div>
                <label className="form-label">
                  Escreva{" "}
                  <span style={{ color: "red", fontWeight: "bolder" }}>
                    "sim, desejo deletar"
                  </span>{" "}
                  e confirme para deletar
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setTextConfirm(e.target.value)}
                />
              </div>
            </>
          )}
        </SweetAlert>
      ) : null}

      <WaitExport
        isOpen={exportInProgress}
        name="Participantes"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      <Card>
        <CardBody>
          <CardTitle>Participantes</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
                width={50}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <Row className="mobile-btns-top">
                  {!props.reportToDashboard && (
                    <div
                      onClick={() => {
                        setTransition(true);
                        setStatus(!status);
                      }}
                    >
                      {!status ? "Filtrar: Ativos" : "Filtrar: Inativos"}
                    </div>
                  )}
                </Row>

                {importers && participants?.length > 0 && (
                  <>
                    <Row className="mobile-btns-top">
                      <div onClick={handleExportParticipants}>
                        Exportar Participantes
                      </div>
                    </Row>
                  </>
                )}

                {checkProductExists("Distribuição de Cotas") &&
                  participants.length > 0 &&
                  !dashAccess && (
                    <Row className="mobile-btns-top">
                      <div
                        onClick={() => {
                          createXlsxQuota({
                            jwt: token,
                            idEvent: idEvent,
                            limit: 1000,
                            countData,
                            setFinishExport,
                          });
                          setExportInProgress(true);
                        }}
                      >
                        Exportar Participantes com Cota(s)
                      </div>
                    </Row>
                  )}

                {!props.reportToDashboard && (
                  <>
                    {importers && (
                      <ActionButtonRounded
                        onClick={() =>
                          setModalImportWrapper(!modalImportWrapper)
                        }
                        title="Importar Participante"
                        type="mobile"
                      />
                    )}
                    <ActionButtonRounded
                      onClick={() => setModalNewParticipant(true)}
                      title="Adicionar Participante"
                      type="mobile"
                    />
                  </>
                )}
              </Collapse>
            </div>
            <div className="header-btns-container">
              {!props.reportToDashboard && (
                <Button
                  color="secondary"
                  className="btn-rounded waves-effect waves-light events-button-add-lg"
                  onClick={() => {
                    setTransition(true);
                    setStatus(!status);
                  }}
                >
                  {!status ? "Filtrar: Ativos" : "Filtrar: Inativos"}
                </Button>
              )}
              {importers && participants.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add-lg"
                  onClick={handleExportParticipants}
                >
                  Exportar Participantes
                </Button>
              )}
              {checkProductExists("Distribuição de Cotas") &&
                !dashAccess &&
                participants.length > 0 && (
                  <Button
                    color="success"
                    className="btn-rounded waves-effect waves-light events-button-add-lg"
                    onClick={() => {
                      createXlsxQuota({
                        jwt: token,
                        idEvent: idEvent,
                        limit: 1000,
                        countData,
                        setFinishExport,
                      });
                      setExportInProgress(true);
                    }}
                  >
                    Exportar Participantes com Cota(s)
                  </Button>
                )}
              {!props.reportToDashboard && (
                <>
                  {importers && (
                    <ActionButtonRounded
                      onClick={() => setModalImportWrapper(!modalImportWrapper)}
                      title="Importar Participante"
                      margin={"0 5px"}
                      className="btn-rounded waves-effect waves-light events-button-add-lg"
                    />
                  )}

                  <ActionButtonRounded
                    onClick={() => setModalNewParticipant(true)}
                    title="Adicionar Participante"
                    className="btn-rounded waves-effect waves-light events-button-add-lg"
                  />
                </>
              )}
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Inscrito em</th>
                  <th>Primeiro acesso</th>
                  {checkProductExists("RSVP") && <th>Status RSVP</th>}
                  {!props.reportToDashboard && <th>Ações</th>}
                </tr>
              </thead>
              <tbody>
                {/* Skeleton em todas as colunas enquanto a lista carrega
                    (tanto no primeiro fetch quanto em reloads). */}
                {loading ? (
                  <LoadingSkelentonTable
                    lines={itemsPerPage}
                    cols={checkProductExists("RSVP") ? 6 : 5}
                  />
                ) : (
                  participants?.map((e) => (
                    <tr key={e.id}>
                      <th>{e.nome}</th>
                      <td>{e.email}</td>

                      <td>{getRegistrationDate(e)}</td>
                      <td>{getFirstAccess(e)}</td>
                      {checkProductExists("RSVP") && (
                        <td>
                          {(() => {
                            const status = getStatusRsvpData(e);
                            if (!status?.description) return null;
                            return (
                              <span
                                style={{
                                  display: "inline-block",
                                  padding: "4px 12px",
                                  borderRadius: 6,
                                  fontSize: 13,
                                  fontWeight: 500,
                                  backgroundColor:
                                    status.backgroundColor || "#e9ecef",
                                  color: status.textColor || "#212529",
                                }}
                              >
                                {status.description}
                              </span>
                            );
                          })()}
                        </td>
                      )}

                      {!props.reportToDashboard && status && (
                        <td>
                          <i
                            className={"mdi mdi-pencil"}
                            style={{
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                              marginRight: 5,
                            }}
                            onClick={() => {
                              setEditParticipante(e);
                              setModalEditParticipant(!modalEditParticipant);
                            }}
                          />

                          {checkProductExists("RSVP") && (
                            <i
                              className="mdi mdi-file-document-outline"
                              style={{
                                color: "#5b73e8",
                                fontSize: 17,
                                cursor: "pointer",
                                marginRight: 5,
                              }}
                              onClick={() => {
                                setParticipantFormData(e);
                                setModalParticipantForm(true);
                              }}
                            />
                          )}

                          {(checkProductExists("APP Eventos Plus") ||
                            checkProductExists("Inteegra MOBI") ||
                            checkProductExists("RSVP")) &&
                            (checkItemMenuLogisticsExists("VOO") ||
                              checkItemMenuLogisticsExists("TRANSFER") ||
                              checkItemMenuLogisticsExists("HOTEL")) && (
                              <i
                                className="fas fa-globe-americas"
                                style={{
                                  color: "#d2d200",
                                  fontSize: 17,
                                  cursor: "pointer",
                                  marginRight: 5,
                                }}
                                onClick={() => {
                                  setLogisticUser(e);
                                  setModalViewLogistics(true);
                                }}
                              />
                            )}

                          {checkItemMenuExists("APP Eventos Plus") &&
                            checkProductExists("APP Eventos Plus") && (
                              <IconButton
                                className="mdi mdi-key"
                                action="U"
                                color="blue"
                                onClick={() => {
                                  setModalEditPassword(true);
                                  setEditParticipante(e);
                                }}
                              />
                            )}
                          <DeleteButton
                            onClick={async () => {
                              setDeleteParticipantState(e);

                              const validDelete =
                                await verifyDeleteParticipant(e);

                              if (validDelete && validDelete.length > 0) {
                                setServiceInUse(validDelete);
                                return;
                              }

                              stepByDelete(e, "noAlert");
                            }}
                            color="red"
                            fontSize={17}
                          />
                        </td>
                      )}
                      {!props.reportToDashboard && !status && (
                        <td>
                          <IconButton
                            className="mdi mdi-account-reactivate"
                            action="U"
                            color="green"
                            onClick={() => {
                              setParticipant(e);
                              setActivateQuotaData(
                                quotas.filter(
                                  (quota) => quota.login === e.id,
                                )[0],
                              );
                              setConfirmAlertReactivate(true);
                            }}
                          />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      {!props.reportToDashboard ? (
        <div
          className="bottom-navigation"
          style={{
            justifyContent: `${
              status && participants?.length > 0 && showDeleteAll
                ? "space-between"
                : "end"
            }`,
          }}
        >
          {participants?.length > 0 && status && (
            <ActionButtonRounded
              onClick={async () => {
                const verifyDelete = await verifyDeleteAllParticipant();
                setTextConfirm("");
                if (verifyDelete && verifyDelete.length > 0) {
                  setServiceInUseEvent(verifyDelete);
                  return;
                }
                setModalDeleteAll(true);
              }}
              title="Limpar Todos Participantes"
              action="D"
              color="danger"
              className="btn-rounded waves-effect waves-light events-button-add-lg"
              setShow={setShowDeleteAll}
              verifyShow={true}
            />
          )}
          <Pagination
            data={participants}
            search={search}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            countData={countData}
            maxItemPerPage={itemsPerPage}
            setMaxItemPerPage={setItemsPerPage}
            maxPageButtonsToShow={3}
          />
        </div>
      ) : (
        <Pagination
          data={participants}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Participants);
